/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Booking_Portal_Price_FromInputs */

const en_booking_portal_price_from = /** @type {(inputs: Booking_Portal_Price_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.price}`)
};

const pl_booking_portal_price_from = /** @type {(inputs: Booking_Portal_Price_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.price}`)
};

/**
* | output |
* | --- |
* | "From {price}" |
*
* @param {Booking_Portal_Price_FromInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_portal_price_from = /** @type {((inputs: Booking_Portal_Price_FromInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Portal_Price_FromInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_portal_price_from(inputs)
	return en_booking_portal_price_from(inputs)
});